import React from 'react';

import {AnalysisGraphQL, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {getDataFrameFilterOptionsForView} from 'analysis-tool/filters/GetDataFrameFilterOptions';
import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';
import DataFrameFilterCreator from 'data-frames/filters/components/DataFrameFilterCreator';
import getUserColumns from 'data-frames/util/getUserColumns';
import Modal from 'ui-library/modals/Modal';

import {DataFrameFilterOptions} from '../DataFrameFilterOptions';

const FIX_FAILED_TRANSFORMS_MESSAGE = 'Fix all failed transformations before adding filters';
const NO_MORE_FILTERS_MESSAGE = 'No more filters can be added because all columns are already filtered';

function getInitialSelectedColumn(
  filterOptions: DataFrameFilterOptions,
  userColumns: Array<DataFrameColumnDef>
): DataFrameColumnDef | undefined {
  const unfilteredColumn = userColumns.find((column) =>
    filterOptions
      ?.getUnfilteredColumns(filterOptions.dataFrameSpec)
      .map((uc) => uc.systemName)
      .includes(column.systemName)
  );

  return unfilteredColumn;
}

export interface FilterEditorModalProps {
  analysis: AnalysisGraphQL;
  viewSteps: Array<GetAnalysisPipelineStep>;
  canSelectColumn: boolean;
  canAddNewFilters: boolean;
  // `onRequestSubmit` must be defined and called in order for `runModal` to work with this component correctly
  onRequestClose: () => void;
}

export default function FilterEditorModal({
  analysis,
  viewSteps,
  canSelectColumn,
  canAddNewFilters,
  onRequestClose,
}: FilterEditorModalProps): JSX.Element {
  const {filterOptions} = getDataFrameFilterOptionsForView(analysis, viewSteps);
  const userColumns = getUserColumns(filterOptions.dataFrameSpec);
  const selectedColumnDef = getInitialSelectedColumn(filterOptions, userColumns);

  return (
    <Modal title="Filter dataset" onRequestClose={onRequestClose} scrollable={true} expandHeight={true}>
      {selectedColumnDef && canAddNewFilters && (
        <div>
          <DataFrameFilterCreator
            canSelectColumn={canSelectColumn}
            columns={userColumns}
            filterOptionsForCreator={filterOptions}
            initialSelectedColumnName={selectedColumnDef.systemName}
            onCancel={onRequestClose}
            onSave={onRequestClose}
          />
        </div>
      )}
      {selectedColumnDef == null && canAddNewFilters && NO_MORE_FILTERS_MESSAGE}
      {!canAddNewFilters && FIX_FAILED_TRANSFORMS_MESSAGE}
    </Modal>
  );
}
